export function resolveBackendBase(env: Record<string, unknown> | undefined): string {
  const record = env && typeof env === 'object' ? (env as Record<string, unknown>) : {}
  const raw = record.VITE_BACKEND_URL || record.VITE_PUBLIC_URL || ''
  const base = typeof raw === 'string' ? raw.trim() : ''
  return base ? base.replace(/\/$/, '') : ''
}

